import { render, staticRenderFns } from "./PersonalityResultsOverview.vue?vue&type=template&id=021ffb7a"
import script from "./PersonalityResultsOverview.vue?vue&type=script&lang=js"
export * from "./PersonalityResultsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports